import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { chain, keys } from "lodash";
import {
  packageDescriptionDefaultText,
  packageDescriptionTypes,
  type PackageDayDescriptionType,
} from "../../admin/packages/PackageDescriptionTypes";
import type { PublicPackageResponse } from "../../publicPackages/publicPackagesApi";

export type FormatType = keyof PublicPackageResponse["days"][number]["details"];
const order = Object.keys(packageDescriptionTypes);

export function FormatSelector(props: {
  value: FormatType;
  onChange(v: FormatType): void;
  forPackage: PublicPackageResponse;
}) {
  const entries = chain(props.forPackage.days)
    .flatMap((day) => day.details)
    .flatMap(keys)
    .uniq()
    .sortBy((key) => order.indexOf(key))
    .map((key) => ({ value: key, label: label(props, key as PackageDayDescriptionType) }))
    .value();
  return (
    <ToggleButtonGroup
      value={props.value}
      exclusive
      onChange={(_, v) => props.onChange(v as FormatType)}
      aria-label="Wybór widoku programu"
      color="primary"
      sx={{
        "& .MuiToggleButton-root": { px: 3, py: 1 },
        "& .MuiToggleButton-root:first-of-type": { borderTopLeftRadius: 32, borderBottomLeftRadius: 32 },
        "& .MuiToggleButton-root:last-of-type": { borderTopRightRadius: 32, borderBottomRightRadius: 32 },
      }}
    >
      {entries.map(({ value, label }) => (
        <ToggleButton key={value} value={value} aria-label={label}>
          <FormatListBulletedIcon sx={{ mr: 1 }} fontSize="small" />
          {label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
function label(
  props: { value: FormatType; forPackage: PublicPackageResponse },
  key: PackageDayDescriptionType,
): string {
  return props.forPackage.detailsDict[key] ?? packageDescriptionDefaultText[key] ?? key;
}
